import { Injectable } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";

export const PlatformResume = 'platform:resume';
export const UserPermissionDataUpdated = 'userPermissionData:updated';
export const KakaoFriendAgreeUpdated = 'kakaoFriendAgree:updated';

@Injectable({
  providedIn: "root"
})
export class Event<T> {
  private subject = new Subject<{
    key: string;
    value: T;
  }>();

  publish(key: string, value: T): void {
    this.subject.next({ key, value });
  }

  subscribe(key: string, next: (value: T) => void): Subscription {
    return this.subject.pipe(
      filter((res) => res.key === key),
      map((res) => res.value)
    ).subscribe((value: T) => {
      next(value);
    })
  }
}